import {Modal} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React from 'react'

import {WebTipsModalProps as Props} from '../types'
import WebTipsIframe from '../WebTipsIframe'
import {classes} from './WebTipsModalDesktop.classes'

function WebTipsModalDesktop({onClose, payUrl}: Props): React.ReactElement<Props> {
  const t = useI18n()

  return (
    <Modal className={classes.root} onClose={onClose} opened>
      <Modal.Header title={t('route_tips_title', 'Чаевые курьеру')} />
      <Modal.Body p={undefined}>
        <WebTipsIframe iframeUrl={payUrl} />
      </Modal.Body>
    </Modal>
  )
}

export default WebTipsModalDesktop
